var app = angular.module("leonardo");

var UnitTaskFilters = function(
  $scope,
  CategoryCacheRestService,
  ReportService,
  $controller
) {

$controller('FiltersBaseController', { $scope: $scope });

$scope.categories = [];

CategoryCacheRestService.getCategories().then(function(response) {
  if (response && response.length > 0) {
    $scope.categories = response.map(function(category) {
      return { id: category.id, name: category.name }; 
    });
  } else {
    console.warn('No categories found or invalid response');
    $scope.categories = []; 
  }
}, function(error) {
  console.error('Failed to fetch categories:', error);
  $scope.categories = []; 
});

$scope.$watch('categories', function(newValue) {
  if (newValue.length > 0) {
    const categoryFilter = $scope.filters_options.find(option => option.id === 'category');
    if (categoryFilter) {
      categoryFilter.options = newValue;
    }
  }
});


  $scope.filters_options = [
    {
      id: 'category',
      name: 'Category',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Categories',
      condition: true,
      options: $scope.categories,
      conflicts: ['sector']
    },
    {
      id: 'priority',
      name: 'Priority',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Priorities',
      condition: true,
      options: ReportService.PRIORITY_OPTIONS,
      conflicts: []
    },
    {
      id: 'unit_number_search',
      name: 'Unit Number',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Unit number',
      condition: true,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'unit_building_search',
      name: 'Unit Building',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Unit building',
      condition: true,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id:'name',
      name:'Keyword Search',
      inline:false,
      type:'text',
      placeholder:'Keyword Search',
      condition:true,
      onSubmit: $scope.filter,
    }
  ];

  $scope.filterService.showFilters(['category', 'priority', 'unit_number_search', 'unit_building_search','name']);
};

app.controller('UnitTaskFilters', [
  '$scope',
  'CategoryCacheRestService',
  'ReportService',
  '$controller',
  UnitTaskFilters
]);